const ppeConfig = {
    apiEndpoint: "https://ppe.finspace.app/api",
    userApiEndpoint: "https://ppe.finspace.app/userapi" 
}

export default ppeConfig;
